import { isRpmEnrollerClinicalCenter } from './rpmEnrollerHelpers';

/**
 * Single gate for secondary vs primary chart (APIs, work items, queue “chart open”, etc.).
 * True when the user is an RPM enroller on a clinical center.
 */
export const usesSecondaryChartAccess = (activeUser, roles) =>
    isRpmEnrollerClinicalCenter(activeUser, roles);

export const usesPrimaryChartAccess = (activeUser, roles) =>
    !usesSecondaryChartAccess(activeUser, roles);

export const getPatientActiveWorkItemId = (patient, activeUser, roles) => {
    if (!patient) {
        return null;
    }
    return usesSecondaryChartAccess(activeUser, roles)
        ? patient.active_work_item_id_secondary
        : patient.active_work_item_id;
};

export const getUserActivePatientId = (activeUser, roles) => {
    if (!activeUser) {
        return null;
    }
    return usesSecondaryChartAccess(activeUser, roles)
        ? activeUser.active_patient_id_secondary
        : activeUser.active_patient_id;
};

/** Patient has an open work item for this user's activity (primary vs secondary). */
export const isPatientChartOpenForActivity = (patient, activeUser, roles) =>
    !!getPatientActiveWorkItemId(patient, activeUser, roles);

export const isCurrentUserPatientChartOpen = (activeUser, patientId, roles) => {
    if (activeUser == null || patientId == null) {
        return false;
    }
    const openPatientId = getUserActivePatientId(activeUser, roles);
    return openPatientId != null && Number(openPatientId) === Number(patientId);
};

export const getMasActivePatientId = (masResponse, activeUser, roles) => {
    if (!masResponse) {
        return null;
    }
    if (usesSecondaryChartAccess(activeUser, roles)) {
        return masResponse.active_patient_id_secondary != null
            ? masResponse.active_patient_id_secondary
            : null;
    }
    return masResponse.active_patient_id != null ? masResponse.active_patient_id : null;
};
